import { fetch as umbrellaFetch } from '@nackle/umbrella';
import { ARCADE_PROJECT_STENCIL } from './constant';
import { apiRootUrl } from '../game-loader-comm-api';

let cypherCacheBundle = {
  stencils: {},
};

// Utility function
export async function getDescription( romId, localeCode = 'en-US', session, isUmbrella = false, env ) {
  if ( !romId ) {return null;}

  // ✅ Check cache
  if (
    cypherCacheBundle.stencils[ romId ]?.[ localeCode ]
  ) {
    return {
      description:
        cypherCacheBundle.stencils[ romId ][ localeCode ][ 'rom.description' ] || '',
    };
  }

  const headers = new Headers();

  if ( session?.access_token ) {
    headers.append( 'Authorization', `Bearer ${ session?.access_token }` );
  }
const baseUrl = `${ apiRootUrl( env, isUmbrella ) }/v1/cypher/stencil-instances?stackCode=${ ARCADE_PROJECT_STENCIL }&localeCode=${ localeCode }&stencilInstanceCode=${ romId }&useCache=false`;
  // ❗ API call
  const response = isUmbrella
  ? await umbrellaFetch( baseUrl )
  : await fetch( baseUrl, {
      method: 'GET',
      headers,
    } );
  
  const result = await response.json();
  if ( result?.stencils ) {
    Object.entries( result.stencils ).forEach( ( [ key, value ] ) => {
      cypherCacheBundle.stencils[ key ] = {
        ...( cypherCacheBundle.stencils[ key ] || {} ),
        ...value,
      };
    } );
  }

  // ✅ IMPORTANT: use actual key
  const stencil = cypherCacheBundle.stencils[ romId ];

  if ( !stencil?.[ localeCode ] ) {return null;}

  return {
    description: stencil[ localeCode ][ 'rom.description' ] || '',
  };
}